<template>
    <CCard>
        <CCardHeader>
            <strong>История изменений</strong>
        </CCardHeader>
        <CCardBody>
            <CDataTable
                hover
                :items="items"
                :fields="fields">
                <template #status="data">
                    <td class="status-cell">
                        <span class="w-2/3 flex items-center gap-1">
                            <CBadge
                                :style="orderStatusStyle(data.item.status)"
                            >&nbsp;{{ orderStatusTitle(data.item.status) }}&nbsp;</CBadge>
                            <CBadge
                                v-if="data.item.payload && data.item.payload.source === 'webhook'"
                                color="info"
                                title="Обновлено через iiko webhook"
                            >WH</CBadge>
                        </span>
                    </td>
                </template>
                <template #created_at="data">
                    <td>
                        {{ getCreatedAt(data.item.created_at) }}
                    </td>
                </template>
                <template #delta="data">
                    <td>
                        {{ getDelta(data.item.delta) }}
                    </td>
                </template>
                <template #from_payment="data">
                    <td>
                        {{ getDelta(data.item.from_payment) }}
                    </td>
                </template>
                <template #actions="data">
                    <td>
                        <CButton
                            @click="showDetailsDialog(data.item.id)"
                        ><CIcon
                            :content="$options.icons.cilInfo"
                        /></CButton>
                    </td>
                </template>
            </CDataTable>
        </CCardBody>

        <CModal
            title="Информация об изменении"
            color="info"
            :show.sync="showDetails"
            :footer="false"
            size="lg"
        >
            <template>
                <div slot="body-wrapper" class="modal-body">
                    <CRow>
                        <CCol sm="4" class="form-group">Заказ</CCol>
                        <CCol sm="8" class="form-group">#{{ logDetails.order_id }}</CCol>
                    </CRow>
                    <CRow>
                        <CCol sm="4" class="form-group">Статус</CCol>
                        <CCol
                            sm="8"
                            class="form-group"
                        ><span
                            class="w-2/3"
                        ><CBadge
                            :style="orderStatusStyle(logDetails.status)"
                        >&nbsp;{{ orderStatusTitle(logDetails.status) }}&nbsp;</CBadge
                        ></span
                        ></CCol
                        >
                    </CRow>
                    <CRow>
                        <CCol sm="4" class="form-group">Дата</CCol>
                        <CCol sm="8" class="form-group">{{
                            formatDate(logDetails.created_at)
                        }}</CCol>
                    </CRow>
                    <CRow>
                        <CCol sm="4" class="form-group">Длительность</CCol>
                        <CCol sm="8" class="form-group">{{
                            getDelta(logDetails.delta)
                        }}</CCol>
                    </CRow>
                    <CRow>
                        <CCol sm="4" class="form-group">От оплаты</CCol>
                        <CCol sm="8" class="form-group">{{
                            getDelta(logDetails.from_payment)
                        }}</CCol>
                    </CRow>
                    <CRow>
                        <CCol sm="4" class="form-group">От создания</CCol>
                        <CCol sm="8" class="form-group">{{
                            getDelta(logDetails.from_creation)
                        }}</CCol>
                    </CRow>
                    <CRow>
                        <CCol sm="4" class="form-group">Подробности</CCol>
                        <CCol sm="8" class="form-group">
                            <pre>{{ logDetailsCode(logDetails.payload) }}</pre>
                        </CCol>
                    </CRow>
                </div>
                <div slot="footer"></div>
            </template>
        </CModal>
    </CCard>
</template>

<script>
    import moment from 'moment';
    import countdown from 'countdown';
    import Vue from 'vue';
    const {
        orderStatusTitle,
        orderStatusStyle,
    } = require('../../utils/order-views');
    const {
        formatDateShort,
        formatTimeShort,
        formatDate
    } = require('../../utils/views');
    import { cilInfo } from '@coreui/icons';

    export default {
        name: 'OrderLogs',

        props: {
            order: {
                type: Object,
                default: () => ({}),
            },
            logs: {
                type: Array,
                default: () => ([]),
            },
        },

        icons: {
            cilInfo,
        },

        data() {
            return {
                isAuthorized: false,
                fieldsAll: [
                    { key: 'status', label: 'Статус', _classes: 'font-weight-bold' },
                    { key: 'created_at', label: 'Изменено' },
                    { key: 'delta', label: 'Длительность' },
                    { key: 'from_payment', label: 'От оплаты' },
                    { key: 'who', label: 'Автор', admin_only: true },
                    { key: 'actions', label: 'Действия' },
                ],
                items: [],
                logDetails: {},
                showDetails: false,
            };
        },

        computed: {
            fields() {
                const result = [];
                for (const item of this.fieldsAll) {
                    if(!this.adminOnly && item.admin_only) {
                        continue;
                    }
                    result.push(item);
                }
                return result;
            },
            adminOnly() {
                return !JSON.parse(localStorage.getItem('settings'))
                    .is_business_admin;
            }
        },

        watch: {
            logs: 'loadData'
        },

        methods: {
            loadData() {
                if (this.logs) {
                    const delta = [null, ...this.logs.map(log => log.delta)] || new Array(8).fill(null);
                    this.items = this.logs.map((log, i) => ({ ...log, delta: delta[i] }));
                } else {
                    this.items = [];
                }
            },
            showDetailsDialog(logId) {
                for (var i = 0; i < this.items.length; i++) {
                    if (logId === this.items[i].id) {
                        this.logDetails = this.items[i];
                    }
                }
                this.showDetails = true;
            },
            orderStatusTitle(status) {
                if (this?.order?.ed?.items?.length) {
                    return orderStatusTitle(
                        status,
                        this.order.type,
                        this.order.payment_type,
                        this?.order?.ed?.items[0]?.entity?.statuses,
                        this.order.delivery_type,
                        this.order.delivered_door,
                    );
                }
                return orderStatusTitle(
                    status,
                    this.order.type,
                    this.order.payment_type,
                    null,
                    this.order.delivery_type,
                    this.order.delivered_door,
                );
            },
            orderStatusStyle(status) {
                return orderStatusStyle(status);
            },
            formatDate(date) {
                return formatDate(date);
            },
            logDetailsCode(details) {
                var code = '';
                if (details) {
                    try {
                        code = JSON.stringify(details, null, 4);
                    } catch (err) {
                        // Nothing to do
                    }
                }
                return code;
            },
            getCreatedAt(created_at) {
                const ca = moment(created_at);
                if (ca.isSame(new Date(), 'day')) {
                    return formatTimeShort(ca.toDate());
                } else {
                    return formatDateShort(ca.toDate());
                }
            },
            getDelta(milliseconds) {
                if (milliseconds) {
                    countdown.setLabels(
                        'мс|с|м|ч|д|н|мес|г|дек|век|мил',
                        'мс|с|м|ч|д|н|мес|г|дек|век|мил',
                        ' ',
                        ', '
                    );
                    const delta = countdown(
                        milliseconds,
                        countdown.DAYS | countdown.HOURS | countdown.MINUTES
                    ).toString();
                    return delta ? delta : 'сейчас';
                } else {
                    return '';
                }
            },
        },
    };
</script>

<style scoped>
.status-cell span {
  display: block;
  width: 100%;
}
.status-cell span span {
  padding: 5px;
}
</style>
